var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showOffersAnimationSection
    ? _c("section", { staticClass: "container-fluid pt-1 pt-md-2" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h2", [_vm._v(_vm._s(_vm.offersAnimation.title))]),
          ]),
          _vm._v(" "),
          _c(
            "ul",
            {
              staticClass: "row list-unstyled",
              attrs: {
                "aria-label":
                  "Liste de " +
                  _vm.offersAnimation.selectionsTileList.length +
                  " forfaits mobiles",
              },
            },
            _vm._l(
              _vm.offersAnimation.selectionsTileList,
              function (selectionTile, index) {
                return _c(
                  "li",
                  { key: index, staticClass: "col-12 col-lg-6 pb-1 pb-lg-2" },
                  [
                    _c(
                      "div",
                      { staticClass: "bg-dark h-100" },
                      [
                        selectionTile.link
                          ? [
                              _c(
                                "a",
                                {
                                  staticClass: "ob1-link no-decoration",
                                  attrs: {
                                    target: "_blank",
                                    href: selectionTile.link,
                                    "data-oevent-category":
                                      selectionTile.tms.category,
                                    "data-oevent-action":
                                      selectionTile.tms.action,
                                    "data-oevent-label":
                                      selectionTile.tms.label,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "h-100 d-flex align-items-center",
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "img-avantages",
                                        attrs: {
                                          loading: "lazy",
                                          src: selectionTile.img.src,
                                          alt: selectionTile.img.alt,
                                          "aria-hidden": "true",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "p-1 text-white" },
                                        [
                                          _c("p", {
                                            directives: [
                                              {
                                                name: "msh-html",
                                                rawName: "v-msh-html",
                                                value: selectionTile.desc,
                                                expression:
                                                  "selectionTile.desc",
                                              },
                                            ],
                                            staticClass:
                                              "lead fw-bold py-0 mb-0",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          : [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "h-100 d-flex align-items-center",
                                },
                                [
                                  _c("img", {
                                    staticClass: "img-avantages",
                                    attrs: {
                                      loading: "lazy",
                                      src: selectionTile.img.src,
                                      alt: selectionTile.img.alt,
                                      "aria-hidden": "true",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-1 text-white" }, [
                                    _c("p", {
                                      directives: [
                                        {
                                          name: "msh-html",
                                          rawName: "v-msh-html",
                                          value: selectionTile.desc,
                                          expression: "selectionTile.desc",
                                        },
                                      ],
                                      staticClass: "lead fw-bold py-0 mb-0",
                                    }),
                                  ]),
                                ]
                              ),
                            ],
                      ],
                      2
                    ),
                  ]
                )
              }
            ),
            0
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }